/* eslint-disable react/no-danger */
import Head from 'next/head';
import settings from '@/settings';
import BackToTopButton from '@/components/collections/BackToTopButton';
import i18n from '@/settings/i18n';
import { getShortenCountryName } from '@/lib/use-origin-country';
import shopify from '@/lib/shopify';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { logger } from '@/lib/logger';

const t = i18n.init();
type PolicyProps = { content: string };

export const getStaticProps = async () => {
  const response = await shopify.fetch({
    query: `query {
              shop {
                privacyPolicy {
                  body
                }
              }
            }`,
    variables: {},
    skipLogging: true,
  });
  const { shop } = response;

  if (shop?.privacyPolicy?.body == null) {
    logger.info('Privacy policy not found or empty');

    return { notFound: true };
  }

  return { props: { content: shop.privacyPolicy.body }, revalidate: 600 };
};

export default function PrivacyPolicy(props: PolicyProps) {
  return (
    <>
      <Head>
        <title>{t`Privacy Policy - Reebelo ${{
          country: getShortenCountryName(),
        }}`}</title>
        <WebsiteSchema />
        <meta
          name="description"
          content={t`Reebelo ${{
            country: settings.country,
          }} is APAC's leading marketplace for sustainable tech with offices in ${{
            offices: settings.country_office_locations,
          }}. The positive customer experience at Reebelo ${{
            country: settings.country,
          }} is of utmost importance to us. Please check here for Reebelo ${{
            country: settings.country,
          }} Privacy Policy.`}
        />
      </Head>
      <BackToTopButton />
      <div className="reebelo-container max-w-[800px] py-8">
        <div
          //  eslint-disable-next-line tailwindcss/no-custom-classname
          className="policies-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: props.content }}
        ></div>
      </div>
    </>
  );
}
